import React from 'react';
import { Folder, Clock, HardDrive, X } from 'lucide-react';
import { Button } from '../common/Button';
import { IconButton } from '../common/IconButton';
import { formatRelativeTime, formatBytes } from '../../utils/format';
import type { RecentProject } from '../../../core/types/project.types';

interface ProjectCardProps {
  project: RecentProject;
  onOpen: () => void;
  onRemove: () => void;
}

export const ProjectCard: React.FC<ProjectCardProps> = ({
  project,
  onOpen,
  onRemove,
}) => {
  const handleRemoveClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRemove();
  };

  return (
    <div
      className="flex items-center justify-between px-4 py-3 hover:bg-gray-750 transition-colors group cursor-pointer"
      onClick={onOpen}
    >
      <div className="flex items-start gap-3 flex-1 min-w-0">
        <div className="p-2 bg-gray-700 rounded-lg group-hover:bg-gray-600 transition-colors">
          <Folder size={20} className="text-blue-400" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-white font-medium truncate group-hover:text-blue-400 transition-colors">
            {project.name}
          </h4>
          <p className="text-gray-500 text-sm truncate" title={project.directoryName || project.path}>
            {project.directoryName || project.path}
          </p>
          <div className="flex items-center gap-4 mt-1 text-xs text-gray-500">
            <span className="flex items-center gap-1">
              <Clock size={12} />
              {formatRelativeTime(project.lastOpened)}
            </span>
            <span className="flex items-center gap-1">
              <HardDrive size={12} />
              {formatBytes(project.size)}
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 ml-4">
        <IconButton
          icon={<X size={14} />}
          onClick={handleRemoveClick}
          title="Remove from list"
          size="sm"
          className="opacity-0 group-hover:opacity-100 transition-opacity"
        />
        <Button variant="primary" size="sm" onClick={(e) => { e.stopPropagation(); onOpen(); }}>
          Open
        </Button>
      </div>
    </div>
  );
};
